import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router, Route } from 'react-router-dom'

import './style.css'
import Privacy from './views/privacy'
import Home from './views/home'
import Help from './views/help'

const App = () => {
  return (
    <Router>
      <div>
        <Route component={Privacy} exact path="/privacy" />
        <Route component={Home} exact path="/" />
        <Route component={Help} exact path="/help" />
      </div>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
